import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertifyService } from '../../services/alertify.service';
import { SystemService } from '../../services/system.service';
import { responseService } from '../../services/response.service';
import * as XLSX from 'xlsx'; // Import XLSX library
import { saveAs } from 'file-saver'; // Import file-saver for saving the file

@Component({
    selector: 'app-res',
    templateUrl: './res.html'
})
export class ResComponent implements OnInit {
    rowData: any[] = []; // All response data from the server
    filteredRowData: any[] = []; // Filtered data based on selected questionnaire
    questionnaireOptions: any[] = []; // Questionnaire options
    uniqueUsers: any[] = []; // Unique users from the response data
    selectedUser: any; // Currently selected user
    QuestionnaireName: string = '';
    selectedQuestionnaire: any = null;

    constructor(
        private router: Router,
        private alertify: AlertifyService,
        private responseService: responseService,
        public service: SystemService
    ) {}

    ngOnInit(): void {
        this.bindData();
        this.QuestionnaireName = this.selectedQuestionnaire?.name || 'Default Questionnaire';
    }

    // Fetch all responses and extract unique users and questionnaires
    bindData() {
        this.service.App.ShowLoader = true;
        this.responseService.getAllResponse().then(data => {
            this.rowData = data;
            this.uniqueUsers = this.extractUniqueUsers(data); // Extract unique users
            this.questionnaireOptions = this.extractQuestionnaireOptions(data); // Extract unique questionnaires
            this.service.App.ShowLoader = false;
        }).catch(error => {
            this.service.App.ShowLoader = false;
            this.alertify.error('Error loading data');
            console.error(error);
        });
    }

    // Extract unique users from the response data
    extractUniqueUsers(data: any[]): any[] {
        const uniqueUsers = Array.from(new Set(data.map(item => item.UserName)))
            .map(name => data.find(item => item.UserName === name));
        return uniqueUsers;
    }

    // Extract unique questionnaire options from the response data
    extractQuestionnaireOptions(data: any[]): any[] {
        const uniqueOptions = Array.from(new Set(data.map(item => item.QuestionnaireName)));
        return uniqueOptions.map(name => {
            const item = data.find(d => d.QuestionnaireName === name);
            return { QuestionnaireName: name, QuestionnaireId: item.QuestionnaireId };
        });
    }

    // Set the selected user and reset filtered data
    selectUser(user: any) {
        this.selectedUser = user;
        this.filteredRowData = []; // Reset filtered data on user selection
    }

    // Filter responses based on selected questionnaire
    filterByQuestionnaire(questionnaireId: string) {
        if (questionnaireId) {
            // Find the selected questionnaire
            this.selectedQuestionnaire = this.questionnaireOptions.find(
                (q) => q.QuestionnaireId === questionnaireId
            );

            // Update the questionnaire name for display
            this.QuestionnaireName = this.selectedQuestionnaire?.QuestionnaireName || 'Default Questionnaire';

            // Filter responses based on the selected questionnaire and user
            this.filteredRowData = this.rowData.filter(
                (row) =>
                    row.QuestionnaireId === questionnaireId &&
                    row.UserName === this.selectedUser?.UserName
            );
        } else {
            this.filteredRowData = this.rowData; // Show all data if no questionnaire is selected
        }
    }

    // Function to export data to Excel
    // Function to export data to Excel
exportToExcel(): void {
    // Extract only specific columns (UserName, QuestionnaireName, ResponseDate)
    const filteredData = this.filteredRowData.map(row => ({
        UserName: row.UserName,
        QuestionnaireName: row.QuestionnaireName,
        QuestionHeadline: row.QuestionHeadline,
        ResponseValue : row.ResponseValue
    }));

    // Create a worksheet from the filtered data
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook: XLSX.WorkBook = { Sheets: { 'Responses': worksheet }, SheetNames: ['Responses'] };

    // Generate a buffer for the workbook
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const fileName = this.selectedUser ? `${this.selectedUser.UserName}_responses_data` : 'responses_data';
    // Save the buffer as a file
    this.saveAsExcelFile(excelBuffer, fileName);
}



saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, `${fileName}_export_${new Date().getTime()}.xlsx`);
}
}

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
